import React, { useState, useEffect, useRef } from "react";
import { Form, InputGroup, Row, Col, Button, Image } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GetBusinessCategoryApi } from "../API/Coupons/GetBusinessCategoryApi";
import Datepickericon from "../../assets/date-picker.svg";
import { getUser } from "../../Utils/LocalStorage";
import { FroalaDefault } from "../../Utils/FroalaDefaultText";
import { FroalaTextEditor } from "../FroalaEditor/FroalaTextEditor";
import defaultupload from "../../assets/default-upload.svg";
import { CreateMarketplaceBusinessCouponApi } from "../API/Coupons/CreateMarketplaceBusinessCouponApi";
import { GetMarketplaceBusinessListApi } from "../API/Coupons/GetMarketplaceBusinessList";
import { GetMarketplaceBusinessTermsConditionApi } from "../API/Coupons/GetMarketplaceBusinessTermsConditionApi";
import { format } from "date-fns";
import BackButton from "../BackButton/BackButton";
import SideBar from "../SideBar/SideBar";
import ImageUploadCrop from "../../Components/ImageUpload/ImageUploadCrop";
import ProductModal from "../modals/ProductModal";
import defaultupload_fb from "../../assets/default-fb.png";
import Modals from "../modals/Modals";
import Warning from "../../assets/Warning.svg";
import ErrorLabel from "../ErrorLabel/ErrorLabel";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CreateCoupon = () => {
  const [startDate, setStartDate] = useState(null);
  const [availableDate, setAvailableDate] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [couponImage, setCouponImage] = useState(null);
  const [socialImage, setSocialImage] = useState(null);
  const [businessList, setBusinessList] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState("");
  const [couponName, setCouponName] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [quantity, setQuantity] = useState("");
  const [selectedMbID, setSelectedMbid] = useState("");
  const [productModalShow, setProductModalShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [dataApihandler, setDataApihandler] = useState({});
  const [description, setDescription] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [couponFile, setCouponFile] = useState(null);
  const [termsList, setTermsList] = useState([]);
  const [selectedTerms, setSelectedTerms] = useState([]);
  const [customTerm, setCustomTerm] = useState("");
  const [couponStatus, setCouponStatus] = useState("");
  const [isCouponImageChange, setIsCouponImageChange] = useState(false);
  const [isSocialImageChange, setIsSocialImageChange] = useState(false);
  const [loading, setLoading] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const availableDateRef = useRef(null);
  const datePickerRef = useRef(null);
  const expiryDateRef = useRef(null);

  // Validation Error States
  const [businessError, setBusinessError] = useState("");
  const [couponNameError, setCouponNameError] = useState("");
  const [couponImageError, setCouponImageError] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");
  const [quantityError, setQuantityError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [availableDateError, setAvailableDateError] = useState("");
  const [expiryDateError, setExpiryDateError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [termsError, setTermsError] = useState("");

  const userData = getUser();

  const navigate = useNavigate();

  const getCategoryList = async () => {
    const res = await GetBusinessCategoryApi(userData.city_id, () => {
      navigate("/");
    });
    if (res) {
      setCategories(res.data || res);
    }
  };

  const handleSocialUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSocialImage(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result.split(",")[1];
        resolve(base64);
      };
      reader.onerror = reject;
    });
  };

  const convertImportedPngToBase64 = async (imageUrl) => {
    // 1. Fetch the image data from your local asset URL
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // 2. Convert that blob into Base64
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const resetForm = () => {
    setSelectedCategory("");
    setSelectedBusiness("");
    setDescription("");
    setCouponName("");
    setCouponCode("");
    setQuantity("");
    setStartDate(null);
    setAvailableDate(null);
    setExpiryDate(null);
    setCouponImage(null);
    setSocialImage(null);
    setSelectedTerms([]);
    setCustomTerm("");
    setCouponFile(null);
    setDataApihandler({});
    setTermsAndConditions("");

    // Reset all error messages
    setBusinessError("");
    setCouponNameError("");
    setCouponImageError("");
    setCouponCodeError("");
    setQuantityError("");
    setStartDateError("");
    setAvailableDateError("");
    setExpiryDateError("");
    setDescriptionError("");
    setTermsError("");
  };

  // 1. validation logic function
  const validateForm = () => {
    let hasError = false;

    setBusinessError("");
    setCouponNameError("");
    setCouponImageError("");
    setCouponCodeError("");
    setQuantityError("");
    setStartDateError("");
    setAvailableDateError("");
    setExpiryDateError("");
    setDescriptionError("");
    setTermsError("");

    if (!selectedBusiness) {
      setBusinessError("Please select a business!");
      hasError = true;
    }
    if (!couponName.trim()) {
      setCouponNameError("Please enter a coupon name!");
      hasError = true;
    }
    if (!couponImage) {
      setCouponImageError("Please upload a coupon image!");
      hasError = true;
    }
    if (!couponCode.trim()) {
      setCouponCodeError("Please enter a coupon code!");
      hasError = true;
    }
    if (!quantity || Number(quantity) <= 0) {
      setQuantityError("Please enter a valid total quantity greater than 0!");
      hasError = true;
    }
    if (!startDate) {
      setStartDateError("Please select a publish start date!");
      hasError = true;
    }
    if (!availableDate) {
      setAvailableDateError("Please select an available until date!");
      hasError = true;
    } else if (startDate && availableDate < startDate) {
      setAvailableDateError(
        "Available date cannot be earlier than start date!",
      );
      hasError = true;
    }
    if (!expiryDate) {
      setExpiryDateError("Please select an expiration date!");
      hasError = true;
    } else if (availableDate && expiryDate < availableDate) {
      setExpiryDateError(
        "Expiration date cannot be earlier than available date!",
      );
      hasError = true;
    }
    if (!description.trim() || description === "<p><br></p>") {
      setDescriptionError("Please enter a coupon description!");
      hasError = true;
    }
    if (selectedTerms.length === 0) {
      setTermsError("Please select at least one term & condition!");
      hasError = true;
    }

    return !hasError;
  };

  const scrollToFirstError = () => {
    setTimeout(() => {
      const errorElements = document.querySelectorAll(".coupon-error-msg");

      let firstActiveError = null;
      for (const el of errorElements) {
        if (el.textContent?.trim()) {
          firstActiveError = el;
          break;
        }
      }

      if (firstActiveError) {
        const parentRow =
          firstActiveError.closest(".row") || firstActiveError.parentElement;

        if (parentRow) {
          parentRow.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });

          const mainContent = document.querySelector(".main-content");
          if (mainContent) {
            const topPos =
              parentRow.getBoundingClientRect().top +
              mainContent.scrollTop -
              150;
            mainContent.scrollTo({
              top: topPos,
              behavior: "smooth",
            });
          }
        }
      }
    }, 100);
  };

  const handleShowModal = (coupon_status) => {
    setCouponStatus(coupon_status);

    if (!validateForm()) {
      scrollToFirstError();
      return;
    }
    setModalShow(true);
    console.log("preview", dataApihandler);
  };

  const handleSaveCoupon = async () => {
    setLoading(true);
    try {
      const payload = {
        category: Number(selectedCategory),
        marketplace_business_id: Number(selectedMbID),
        coupon_name: couponName,
        coupon_code: couponCode,
        expiry_start_date: format(startDate, "yyyy-MM-dd"),
        coupon_avail_until_date: format(availableDate, "yyyy-MM-dd"),
        expiry_end_date: format(expiryDate, "yyyy-MM-dd"),
        description,
        tnc: selectedTerms,
        is_image_changed: isCouponImageChange,
        coupon_social_image_path: {
          data: socialImage || null,
          file_type: "png",
        },
        coupon_status: couponStatus,
        total_quantity: quantity,
        is_social_image: isSocialImageChange,
        mms_city_id: userData?.city_id,
        image_path: {
          data: couponImage,
          file_type: "png",
        },
      };

      const response = await CreateMarketplaceBusinessCouponApi(payload, () => {
        navigate("/");
      });

      if (response.success) {
        resetForm();
        setModalShow(false);
        navigate("/coupons/my-coupons");
        toast.success(response.message, {
          position: "top-center",
          width: "500px",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.error(response.message || "Coupon already exists!", {
          position: "top-center",
          width: "500px",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while creating coupon.", {
        position: "top-center",
        width: "500px",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } finally {
      setLoading(false);
      setModalShow(false);
    }
  };

  const getBusinessList = async () => {
    const res = await GetMarketplaceBusinessListApi(()=> {
      navigate("/");
    });
    if (res) {
      setBusinessList(res.data || res);
    }
  };

  useEffect(() => {
    getBusinessList();
  }, []);

  const selectValueFromOption = (e) => {
    if (!e) {
      setSelectedMbid("");
      setSelectedCategory("");
      setSelectedBusiness("");
      return;
    }
    const splitSelectedValue = e.split("|");
    setSelectedMbid(splitSelectedValue[1]);
    setSelectedCategory(splitSelectedValue[0]);
    setSelectedBusiness(splitSelectedValue[2]);
    setBusinessError("");
  };

  const getTermsList = async () => {
    const res = await GetMarketplaceBusinessTermsConditionApi();
    if (res?.tnc) {
      setTermsList(res.tnc);
    } else {
      setTermsList([]);
    }
  };

  useEffect(() => {
    getTermsList();
  }, []);

  const handleTermChange = (term) => {
    let updatedTerms = [];
    if (selectedTerms.includes(term)) {
      updatedTerms = selectedTerms.filter((item) => item !== term);
    } else {
      updatedTerms = [...selectedTerms, term];
    }
    setSelectedTerms(updatedTerms);
    if (updatedTerms.length > 0) setTermsError("");
  };

  const handleAddTerm = () => {
    const trimmedTerm = customTerm.trim();

    if (!trimmedTerm) return;

    const isDuplicate = termsList.some(
      (term) => term.trim().toLowerCase() === trimmedTerm.toLowerCase(),
    );

    if (isDuplicate) {
      setTermsError("This term & condition already exists in the list!");
      return;
    }

    setTermsList((prev) => [...prev, trimmedTerm]);
    setSelectedTerms((prev) => {
      const updated = [...prev, trimmedTerm];
      if (updated.length > 0) setTermsError("");
      return updated;
    });

    setCustomTerm("");
    setTermsError("");
  };

  const handleSubmit = (e, type) => {
    e.preventDefault();
    if (type === "preview") {
      if (!validateForm()) {
        scrollToFirstError();
        return;
      }
      setProductModalShow(true);
    }
  };

  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Create Coupon</p>

          <div className="acc-dashboard mt-4">
            <Form className="formmain mx-0 mt-2 signin-row profile-form pb-4">
              {/* Business & Coupon Name */}
              <Row className="mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Business <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      value={`${selectedCategory}|${selectedMbID}|${selectedBusiness}`}
                      onChange={(e) => selectValueFromOption(e.target.value)}
                      className="cursor-pointer"
                    >
                      <option value="">Select Business</option>
                      {businessList?.map((item) => (
                        <option
                          key={item.mb_id}
                          value={`${item.category}|${item.mb_id}|${item.business_name}`}
                        >
                          {item.business_name}
                        </option>
                      ))}
                    </Form.Select>
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={businessError} />
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Coupon Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={couponName}
                      onChange={(e) => {
                        setCouponName(e.target.value);
                        if (e.target.value.trim()) setCouponNameError("");
                      }}
                      placeholder="Enter coupon name"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={couponNameError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Upload Images */}
              <Row className="mb-2 gy-4">
                {/* Takes full width on smaller/medium screens, drops to 4 columns only on large screens */}
                <Col xs={12} lg={4} className="mt-lg-5">
                  <ImageUploadCrop
                    imgType="logo_img"
                    aspect={1 / 1}
                    recommendedSize="1000px x 1000px"
                    label="Coupon"
                    croppedImage={couponImage}
                    setCroppedImage={(img) => {
                      setCouponImage(img);
                      if (img) setCouponImageError("");
                    }}
                    isSetImageChange={setIsCouponImageChange}
                  />
                  <div className="coupon-error-msg">
                    <ErrorLabel ErrorDisplay={couponImageError} />
                  </div>
                </Col>

                {/* Takes full width and cleanly drops underneath the first image when space is limited */}
                <Col xs={12} lg={8} className="mt-lg-4">
                  <ImageUploadCrop
                    imgType="fb_img"
                    aspect={1200 / 630}
                    recommendedSize="1200px x 630px"
                    label="Social Share"
                    croppedImage={socialImage}
                    setCroppedImage={setSocialImage}
                    isSetImageChange={setIsSocialImageChange}
                  />
                </Col>
              </Row>

              {/* Coupon Code & Quantity */}
              <Row className="mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Coupon Code <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={couponCode}
                      onChange={(e) => {
                        setCouponCode(e.target.value);
                        if (e.target.value.trim()) setCouponCodeError("");
                      }}
                      placeholder="Enter coupon code"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={couponCodeError} />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Total Quantity <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={quantity}
                      onChange={(e) => {
                        setQuantity(e.target.value);
                        if (e.target.value && Number(e.target.value) > 0)
                          setQuantityError("");
                      }}
                      placeholder="Enter Total Quantity"
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={quantityError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Dates */}
              <Row className="mb-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Coupon Publish Start Date{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <DatePicker
                        ref={datePickerRef}
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                          if (date) setStartDateError("");
                        }}
                        className="form-control cursor-pointer"
                        dateFormat="dd MMM yyyy"
                        minDate={new Date()}
                        maxDate={availableDate || null}
                        placeholderText="Select Start Date"
                      />
                      <Image
                        src={Datepickericon}
                        className="date-picker-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => datePickerRef.current?.setOpen(true)}
                      />
                    </InputGroup>
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={startDateError} />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Coupon Available Until Date{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <DatePicker
                        ref={availableDateRef}
                        selected={availableDate}
                        onChange={(date) => {
                          setAvailableDate(date);
                          if (date) setAvailableDateError("");
                        }}
                        minDate={startDate || new Date()}
                        maxDate={expiryDate || null}
                        className="form-control cursor-pointer"
                        dateFormat="dd MMM yyyy"
                        placeholderText="Available Until Date"
                      />
                      <Image
                        src={Datepickericon}
                        className="date-picker-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => availableDateRef.current?.setOpen(true)}
                      />
                    </InputGroup>
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={availableDateError} />
                    </div>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label>
                      Coupon Expiration Date{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <DatePicker
                        ref={expiryDateRef}
                        selected={expiryDate}
                        onChange={(date) => {
                          setExpiryDate(date);
                          if (date) setExpiryDateError("");
                        }}
                        minDate={availableDate || startDate || new Date()}
                        className="form-control cursor-pointer"
                        dateFormat="dd MMM yyyy"
                        placeholderText="Select Expiry Date"
                      />
                      <Image
                        src={Datepickericon}
                        className="date-picker-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => expiryDateRef.current?.setOpen(true)}
                      />
                    </InputGroup>
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={expiryDateError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Description */}
              <Row className="mb-2">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>
                      Coupon Description <span className="text-danger">*</span>
                    </Form.Label>
                    <FroalaTextEditor
                      TemplateContent={description}
                      setTemplateContent={(content) => {
                        setDescription(content);
                        if (content.trim() && content !== "<p><br></p>")
                          setDescriptionError("");
                      }}
                    />
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={descriptionError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Terms */}
              <Row className="mb-5 mt-2">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>
                      Terms & Conditions <span className="text-danger">*</span>{" "}
                      <span className="span-italic">
                        You can select terms &amp; conditions listed below or
                        you can add more.
                      </span>
                    </Form.Label>
                    <div
                      style={{
                        background: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                      }}
                    >
                      {termsList?.map((item, index) => (
                        <div key={index} className="Custom-T-C-list">
                          <Form.Check
                            type="checkbox"
                            label={item}
                            className="form-check-label"
                            style={{ display: "flex", gap: 10 }}
                            checked={selectedTerms.includes(item)}
                            onChange={() => handleTermChange(item)}
                          />
                        </div>
                      ))}
                      <InputGroup className="search-bar add-bar tcAdd mt-3">
                        <Form.Control
                          placeholder="Add More"
                          value={customTerm}
                          className="addmor"
                          maxLength="200"
                          autoComplete="off"
                          onChange={(e) => setCustomTerm(e.target.value)}
                        />
                        <Button
                          className="btn btn-outline-secondary"
                          onClick={handleAddTerm}
                        >
                          + Add
                        </Button>
                      </InputGroup>
                    </div>
                    <div className="coupon-error-msg">
                      <ErrorLabel ErrorDisplay={termsError} />
                    </div>
                  </Form.Group>
                </Col>
              </Row>

              {/* Action Buttons */}
              <div className="text-center gap-4 small-btns d-flex mt-4">
                <button
                  className="green-btn mt-3 update-Btn"
                  onClick={(e) => handleSubmit(e, "preview")}
                >
                  Preview
                </button>
                <Button
                  className="discard_btn"
                  variant="primary"
                  onClick={() => handleShowModal("draft")}
                >
                  Save As draft
                </Button>
              </div>

              <div className="d-flex gap-4 justify-content-center mt-4">
                <Button
                  className="discard_btn"
                  variant="secondary"
                  onClick={() => {
                    navigate("/coupons/my-coupons/");
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="green-btn mt-3 update-Btn"
                  variant="primary"
                  onClick={() => handleShowModal("published")}
                >
                  Save
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <Modals
        show={modalShow}
        onHide={() => setModalShow(false)}
        images={Warning}
        description={
          couponStatus === "draft"
            ? "Your coupon has been saved as a draft. You can edit and publish it at any time"
            : "Your coupon is almost ready! Click 'Yes' to finish creating, but remember, once created you cannot delete the coupon but can always disable it whenever you want. This will not affect the customers who might have already downloaded the coupon, they can still redeem it."
        }
        firstbutton="No"
        secondbutton="Yes"
        loading={loading}
        saveButtonfuc={handleSaveCoupon}
      />

      <ProductModal
        className="Modal_Popup"
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        dat={dataApihandler}
        flag="Coupon"
        product_name={couponName}
        product_image={couponImage}
        availableDat={availableDate}
        endDat={expiryDate}
        product_value={quantity}
        product_price={quantity}
        description={description}
        tnc={selectedTerms}
        business_name={selectedBusiness}
      />
    </>
  );
};

export default CreateCoupon;
